import { Agreement } from 'storage/agreements/agreements.model';

export const findKisaAgreementsIds = (agreements: Agreement[]) =>
  agreements.reduce((ids: number[], agreement) => {
    const {
      generalData: { agreementId, fromUgodowi }
    } = agreement;
    if (fromUgodowi) {
      ids.push(agreementId);
    }
    return ids;
  }, []);
